import * as React from "react";
import { connect } from "react-redux";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { selectOutskirtBuildingCurrentLevel } from "../../selectors/selectOutskirtBuildingInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { Improvement } from "../improvement/Improvement";
import { ButtonResearchItemUpgradeLibrary } from "./ButtonResearchItemUpgradeLibrary";
var _DetailViewLibrary = function (_a) {
    var item = _a.item, libraryStage = _a.libraryStage;
    if (!item) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Improvement, { item: item, buildingStage: libraryStage, buildingId: IdOutskirtBuildings.Library, lockedLevelButton: React.createElement(ButtonResearchItemUpgradeLibrary, null), lockedLevelText: IdLoca.research_requiredLibraryLevel }));
};
var mapState = function (state) { return ({
    libraryStage: selectOutskirtBuildingCurrentLevel(state, IdOutskirtBuildings.Library),
}); };
export var DetailViewLibrary = connect(mapState)(_DetailViewLibrary);



//////////////////
// WEBPACK FOOTER
// ./src/features/library/DetailViewLibrary.tsx
// module id = 2688
// module chunks = 3